/**
 * 配置浏览器本地存储的方式，可直接存储对象数组。
 */

import WebStorageCache from 'web-storage-cache'

type CacheType = 'localStorage' | 'sessionStorage'

export const CACHE_KEY = {
  USER: 'user',
  LOGIN_FORM: 'loginForm',
  UDB_AUTH_CODE: 'udbAuthCode',
  POOL_NO: 'poolNo',
  POOL_NAME: 'poolName'
}

export const useCache = (type: CacheType = 'localStorage') => {
  const wsCache: WebStorageCache = new WebStorageCache({
    storage: type
  })

  return {
    wsCache
  }
}
